import { SessionService } from './session.service';
import { NgModule } from '@angular/core';
import { StoreService } from './store.service';
import { CryptoService } from './crypto.service';
import { LoadingContentService } from './loading-content.service';
import { DomService } from './dom.service';
import { EventService } from './event.service';
import { GlobalService } from './global.service';
import { RenderComponentService } from './render.service';
import { LazyLoadingScriptService } from './script.service';
import { DomValidationService } from './forms/dom-validation.service';
import { ValidationMessageService } from './forms/validation-message.service';
import { ViewService } from './view.service';

@NgModule({
	providers: [
		CryptoService,
		EventService,
		GlobalService,
		SessionService,
		StoreService,
		LoadingContentService,
		DomService,
		RenderComponentService,
		LazyLoadingScriptService,
		DomValidationService,
		ValidationMessageService,
		ViewService
	]
})
export class CiptechServicesModule { }
